<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div v-once ref="htmlRef" v-html="htmlCode"></div>
</template>

<script>
import { defineComponent, onMounted, ref, computed } from '@nuxtjs/composition-api';
/**
 * Renders html to the dom
 *
 * @example
 * <RenderHtml :html="customHtml" />
 */
export default defineComponent({
  props: {
    html: {
      type: String,
    },
  },
  setup(props) {
    const htmlRef = ref(null);
    const htmlCode = ref('');
    const isProject = computed(() => props.html?.includes('oio.init'));
    if (isProject.value) {
      htmlCode.value = props.html;
    }
    onMounted(() => {
      if (isProject.value) return;
      const postscribe = require('postscribe');
      postscribe(htmlRef.value, props.html);
    });

    return { htmlRef, htmlCode };
  },
});
</script>
